export default "__VITE_ASSET__$E1nXxOQ__"